<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { sameAs } from '@vuelidate/validators'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Show ALL Tilgreind_Sereign steps in summary
import Step1 from './Step1.vue'
import Step2 from './Step2.vue'
import Step3 from './Step3.vue'
import Step4 from './Step4.vue'
import Step5 from './Step5.vue'
import Step6 from './Step6.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// Require final confirmation (same pattern as Makalífeyrir)
const rules = {
  umsokn: {
    confirm: { sameAs: sameAs(true) },
  },
}
const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  },
})
</script>

<template>
  <div v-if="umsokn" class="col-sm-12">
    <v-col>
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('lifeyri_umsokn_step6_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Plain, non-collapsible summary (read-only) -->
      <v-row>
        <v-col class="application__summary">
          <div class="m-t-100"><Step1 :umsokn="umsokn" :disable="true" /></div>
          <div class="m-t-100"><Step2 :umsokn="umsokn" :disable="true" /></div>
          <div class="m-t-100"><Step3 :umsokn="umsokn" :disable="true" /></div>
          <div class="m-t-100"><Step4 :umsokn="umsokn" :disable="true" /></div>
          <div class="m-t-100"><Step5 :umsokn="umsokn" :disable="true" /></div>
          <div class="m-t-100"><Step6 :umsokn="umsokn" :disable="true" /></div>
        </v-col>
      </v-row>

      <!-- Agreement header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('lifeyri_umsokn_step6_header3') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Disclaimer -->
      <v-row>
        <v-col>
          <p class="forms__paragraph">
            {{ t('lifeyri_umsokn_step6_disclaimer_text') }}
          </p>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
